import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import { required } from 'form/validation';

import { TextField, showErrorOnBlur } from 'mui-rff';

const ParakeyStorageSiteLockConfigurationEditor = ({ fieldNamePrefix }) => {
    const getName = suffix => suffix ? `${fieldNamePrefix}.${suffix}` : fieldNamePrefix;
    return (
        <TextField
            label={strings.parakeyDomain}
            name={getName('domainId')}
            variant="outlined"
            helperText={strings.parakeyDomainHelperText}
            showError={showErrorOnBlur}
            required
            fieldProps={{ validate: required }}
        />
    );
};

ParakeyStorageSiteLockConfigurationEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired
};

export default ParakeyStorageSiteLockConfigurationEditor;
